<script setup lang="ts">
</script>

<template>
  <div class="base-footer flex justify-center">
    <div class="w-1200px pt-vh-40px pb-vh-40px mt-vh-40px bt-1-solid flex flex-col items-center" :style="{ 'border-color': 'var(--border-color)' }">
      <h3 class="text-20px font-700">TechBlog</h3>
      <p class="text-14px mb-vh-15px">© 2023 TechBlog. All Rights Reserved.</p>
      <p class="text-14px">分享技术，连接未来。探索编程世界的无限可能，一起成长，共同进步。</p>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>